"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUISettings = exports.useTokenEndpoint = exports.useSubscribedNotifications = exports.useSetUiSettings = exports.useSetSubscribedNotifications = exports.useSetAppDataByKey = exports.useLogo = exports.useIsRTMPStartedFromUI = exports.useIsHeadless = exports.useIsHLSStartedFromUI = exports.useHLSViewerRole = void 0;
var _react = require("react");
var _reactSdk = require("@100mslive/react-sdk");
var _useUserPreferences3 = require("../hooks/useUserPreferences");
var _constants = require("../../common/constants");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * fields saved related to UI settings in store's app data can be
 * accessed using this hook. key is optional if not passed
 * the whole UI settings object is returned. Usage -
 * 1. val = useUiSettings("isAudioOnly");
 *    console.log(val); // false
 * 2. val = useUISettings();
 *    console.log(val); // {isAudioOnly: false}
 * @param {string | undefined} uiSettingKey
 */
var useUISettings = function useUISettings(uiSettingKey) {
  var uiSettings = (0, _reactSdk.useHMSStore)((0, _reactSdk.selectAppDataByPath)(_constants.APP_DATA.uiSettings, uiSettingKey));
  return uiSettings;
};

/**
 * fields saved related to UI settings in store's app data can be
 * accessed using this hook. key is optional if not passed
 * the whole UI settings object is returned. Usage -
 * [val, setVal] = useUiSettings("isAudioOnly");
 * console.log(val); // false
 * setVal(true);
 * @param {string} uiSettingKey
 */
exports.useUISettings = useUISettings;
var useSetUiSettings = function useSetUiSettings(uiSettingKey) {
  var value = useUISettings(uiSettingKey);
  var setValue = useSetAppData({
    key1: _constants.APP_DATA.uiSettings,
    key2: uiSettingKey
  });
  return [value, setValue];
};
exports.useSetUiSettings = useSetUiSettings;
var useIsHeadless = function useIsHeadless() {
  var isHeadless = useUISettings(_constants.UI_SETTINGS.isHeadless);
  return isHeadless;
};
exports.useIsHeadless = useIsHeadless;
var useHLSViewerRole = function useHLSViewerRole() {
  return (0, _reactSdk.useHMSStore)((0, _reactSdk.selectAppData)(_constants.APP_DATA.hlsViewerRole));
};
exports.useHLSViewerRole = useHLSViewerRole;
var useIsHLSStartedFromUI = function useIsHLSStartedFromUI() {
  return (0, _reactSdk.useHMSStore)((0, _reactSdk.selectAppData)(_constants.APP_DATA.hlsStarted));
};
exports.useIsHLSStartedFromUI = useIsHLSStartedFromUI;
var useIsRTMPStartedFromUI = function useIsRTMPStartedFromUI() {
  return (0, _reactSdk.useHMSStore)((0, _reactSdk.selectAppData)(_constants.APP_DATA.rtmpStarted));
};
exports.useIsRTMPStartedFromUI = useIsRTMPStartedFromUI;
var useTokenEndpoint = function useTokenEndpoint() {
  return (0, _reactSdk.useHMSStore)((0, _reactSdk.selectAppData)(_constants.APP_DATA.tokenEndpoint));
};
exports.useTokenEndpoint = useTokenEndpoint;
var useLogo = function useLogo() {
  return (0, _reactSdk.useHMSStore)((0, _reactSdk.selectAppData)(_constants.APP_DATA.logo));
};
exports.useLogo = useLogo;
var useSubscribedNotifications = function useSubscribedNotifications(notificationKey) {
  var notificationPreference = (0, _reactSdk.useHMSStore)((0, _reactSdk.selectAppDataByPath)(_constants.APP_DATA.subscribedNotifications, notificationKey));
  return notificationPreference;
};
exports.useSubscribedNotifications = useSubscribedNotifications;
var useSetSubscribedNotifications = function useSetSubscribedNotifications(notificationKey) {
  var value = useSubscribedNotifications(notificationKey);
  var setValue = useSetAppData({
    key1: _constants.APP_DATA.subscribedNotifications,
    key2: notificationKey
  });
  return [value, setValue];
};
exports.useSetSubscribedNotifications = useSetSubscribedNotifications;
var useSetAppDataByKey = function useSetAppDataByKey(appDataKey) {
  var value = (0, _reactSdk.useHMSStore)((0, _reactSdk.selectAppData)(appDataKey));
  var actions = (0, _reactSdk.useHMSActions)();
  var setValue = (0, _react.useCallback)(function (value) {
    actions.setAppData(appDataKey, value);
  }, [actions, appDataKey]);
  return [value, setValue];
};
exports.useSetAppDataByKey = useSetAppDataByKey;
var useSetAppData = function useSetAppData(_ref) {
  var key1 = _ref.key1,
    key2 = _ref.key2;
  var actions = (0, _reactSdk.useHMSActions)();
  var store = (0, _reactSdk.useHMSVanillaStore)();
  var _useUserPreferences = (0, _useUserPreferences3.useUserPreferences)(_useUserPreferences3.UserPreferencesKeys.UI_SETTINGS),
    _useUserPreferences2 = _slicedToArray(_useUserPreferences, 2),
    setPreferences = _useUserPreferences2[1];
  var setValue = (0, _react.useCallback)(function (value) {
    if (!key1) {
      return;
    }
    actions.setAppData(key1, key2 ? _defineProperty({}, key2, value) : value, true);
    var appData = store.getState((0, _reactSdk.selectAppData)());
    setPreferences(_objectSpread(_objectSpread({}, appData.uiSettings), {}, {
      subscribedNotifications: appData.subscribedNotifications
    }));
  }, [actions, key1, key2, store, setPreferences]);
  return setValue;
};